import { render, staticRenderFns } from "./SvnStatus.vue?vue&type=template&id=5d138cb5&scoped=true&"
import script from "./SvnStatus.vue?vue&type=script&lang=js&"
export * from "./SvnStatus.vue?vue&type=script&lang=js&"
import style0 from "./SvnStatus.vue?vue&type=style&index=0&id=5d138cb5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d138cb5",
  null
  
)

export default component.exports